module.exports = __webpack_public_path__ + "static/fipcpastelfloral3-03fd8cf060ee292315ffa91b26c68af8.jpeg";